import { Box, Flex, VStack } from '@chakra-ui/react';
import LoginForm from 'components/Login/LoginForm';
import { bucketUrl } from 'utils/files';
import { ISettings } from 'types';
import { ThemeContext } from 'contexts/themeContext';
import { Image, Link } from 'components/UI';
import image from 'resources/shutterstock_691534279.jpg';
import variantLogo1 from 'resources/Variant_whitetext_EN.png';
import AppRoutes from 'constants/routes';

const LoginScreen = () => {
  const renderCompanyLogo = (theme: ISettings | null) =>
    theme?.loginLogo ? (
      <Flex
        sx={{
          flex: '1 1',
          flexDir: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Image
          src={`${bucketUrl}/${theme?.loginLogo}`}
          alt="Company logo"
          sx={{
            w: 400,
            display: 'flex',
            justifyContent: 'center',
            p: 8,
          }}
        />
      </Flex>
    ) : null;

  return (
    <ThemeContext.Consumer>
      {(theme: ISettings | null) => (
        <Flex flex={1} h="100vh" data-testid="login-page">
          <Flex flex={1}>
            <Flex
              data-testid="login-background-image"
              sx={{
                bgImage: `url(${theme?.loginBackgroundImage ? `${bucketUrl}/${theme?.loginBackgroundImage}` : image})`,
                bgSize: theme?.loginBackgroundImage ? 'cover' : '2000px 1000px',
                flex: '1 1',
              }}
            >
              <Flex
                sx={{
                  flex: '1 1',
                  flexDir: 'column',
                  bg: 'linear-gradient( 310deg, var(--chakra-colors-base2Colour-400) 0%, var(--chakra-colors-base2Colour-400) 20%, rgba(84, 84, 84, 0.8) 70%, rgba(84, 84, 84, 0.8) 100% )',
                  bgSize: '1500px 2000px',
                  bgPos: '-700px 1100px',
                  justifyContent: 'space-between',
                }}
              >
                <Flex
                  sx={{
                    flex: 2,
                    alignItems: 'flex-start',
                    p: 5,
                  }}
                >
                  <Image src={variantLogo1} alt="solidcad logo" w={150} justifyContent="flex-start" bg="none" />
                </Flex>
                {renderCompanyLogo(theme)}
                <Box flex={4} />
              </Flex>
            </Flex>
            <Flex flex="1 1" alignItems="center">
              <VStack flex="1 1">
                <Box maxWidth={360} my={0} mx="auto">
                  <LoginForm overlay={false} />
                  <Box textAlign="center" mt={4}>
                    <Link to={AppRoutes.ForgotPassword} color="primaryThemeColour.400">
                      Lost your password?
                    </Link>
                  </Box>
                </Box>
              </VStack>
            </Flex>
          </Flex>
        </Flex>
      )}
    </ThemeContext.Consumer>
  );
};

export default LoginScreen;
